var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"tooltip",style:(_vm.getStyles())},[_c('div',{staticClass:"box",style:(_vm.getColor())},[_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.text)+" ")])]),_c('div',{staticClass:"tip-wrapper"},[_c('n-tooltip-tip',{staticClass:"tip",attrs:{"fill":_vm.color}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }